import getHelper from '../../../services/getHelper';

export default getHelper('/student-credentials/:id');
